const STORAGE_KEY = 'swell-theme';
const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

function getSystemTheme() {
  return mediaQuery.matches ? 'dark' : 'light';
}

export function getActiveTheme() {
  const stored = localStorage.getItem(STORAGE_KEY) || 'system';
  return stored === 'system' ? getSystemTheme() : stored;
}

// Raw stored preference (including 'system'); getActiveTheme() resolves it.
export function getStoredTheme() {
  return localStorage.getItem(STORAGE_KEY) || 'system';
}

export function syncThemeToIframe(iframeRef) {
  function send() {
    const iframe = iframeRef.current;
    if (!iframe?.contentWindow) return;
    iframe.contentWindow.postMessage(
      { type: 'SET_THEME', theme: getActiveTheme() },
      '*',
    );
  }

  mediaQuery.addEventListener('change', send);

  const observer = new MutationObserver(send);
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['data-theme'],
  });

  return () => {
    mediaQuery.removeEventListener('change', send);
    observer.disconnect();
  };
}

function setDataTheme(theme) {
  document.documentElement.setAttribute('data-theme', theme);
}

function onSystemThemeChange() {
  setDataTheme(getSystemTheme());
}

export function applyTheme(theme = 'system') {
  localStorage.setItem(STORAGE_KEY, theme);
  mediaQuery.removeEventListener('change', onSystemThemeChange);

  if (theme === 'system') {
    setDataTheme(getSystemTheme());
    mediaQuery.addEventListener('change', onSystemThemeChange);
  } else {
    setDataTheme(theme);
  }
}

// Respond to GET_THEME requests from iframes
window.addEventListener('message', (event) => {
  if (event.data?.type === 'GET_THEME' && event.source) {
    event.source.postMessage(
      { type: 'SET_THEME', theme: getActiveTheme() },
      event.origin,
    );
  }
});
